/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SyncDocumentRequest} from '@cash-web/protos/squareup/stafftasks/managertodos/endpoints/sync-document.pb'
import {SyncDocumentResponse} from '@cash-web/protos/squareup/stafftasks/managertodos/endpoints/sync-document.pb'


export const syncDocument = (request: SyncDocumentRequest, options?: CashRequestOptions) => post<SyncDocumentRequest, SyncDocumentResponse>("/2.0/cash/sync-document", request, {...options, rejectOnError: true })